import { render, staticRenderFns } from "./ConnectUs.vue?vue&type=template&id=2bcc0663&scoped=true"
import script from "./ConnectUs.vue?vue&type=script&lang=js"
export * from "./ConnectUs.vue?vue&type=script&lang=js"
import style0 from "./ConnectUs.vue?vue&type=style&index=0&id=2bcc0663&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcc0663",
  null
  
)

export default component.exports